import React, { useEffect } from "react";

// The fullscreen preview overlay the studio editors open from
// ViewControls' breakout button. Escape closes it, the page behind is
// locked from scrolling, and the exit button sits top right.
//
// Lifted out of survey/Edit.jsx, which had the most complete version of
// what capform and widget were each duplicating.
const FullscreenPreview = ({ url, onClose, title = "Fullscreen preview" }) => {
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [onClose]);

  return (
    <div className="fixed inset-0 z-[100] bg-black">
      <iframe src={url} className="w-full h-full block bg-white border-0" title={title} />
      <button
        type="button"
        onClick={onClose}
        className="absolute top-4 right-4 z-10 inline-flex items-center gap-1.5 px-3 py-2 text-xs font-bold uppercase tracking-wider bg-white border-[2px] border-black text-slate-900 hover:bg-ssyellow shadow-[3px_3px_0_rgba(0,0,0,0.4)]"
      >
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2.5" stroke="currentColor" className="h-3.5 w-3.5">
          <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
        </svg>
        exit fullscreen
        <span className="hidden sm:inline opacity-50 ml-1">esc</span>
      </button>
    </div>
  );
};

export { FullscreenPreview };
export default FullscreenPreview;
